import React, { FC, useState } from 'react'
import DisableContextMenu from 'components/DisableContextMenu'
import VisibilityTrigger from 'components/VisibilityTrigger'
import Breadcrumb from 'components/SA/Breadcrumb'
import { slugify } from 'lib/slugify'
import { capitalizeString } from 'lib/helpers'
import RelatedSearches from '../components/RelatedSearches/RelatedSearches'
import { MainContent } from '../components/styles/layout'
import ArtworkDescriptionSection from '../components/ArtworkDescriptionSection'
import AboutArtist from '../components/AboutArtist'
import USPSection from '../components/USPSection/USPSection'
import LayoutConnector, { ConnectorProps as LayoutProps } from '../connectors/Layout'
import Admin from './Admin'
import Carousels from './Carousels'
import Products from './Products'
import AASection from '../components/AASection/AASection'
import Gallery from '../components/Gallery'
import { getLinkCategory } from 'apps/saatchi/artdetail2/helpers'
import styles from './ArtDetail2.module.scss'
import useSearchProvider from 'hooks/useSearchProvider'
import { useSelector } from 'react-redux'
import { getArtworkId, getArtworkTitle } from '../selectors/artwork'
import {
  getCurrentProductType,
  getOriginalProductListPrice,
  getSelectedProduct,
  getSelectedProductSku,
  getTotalPriceInCentsOfSelectedOptions,
} from '../selectors/product'
import { PRINT } from '../helpers/constants'

const PDPLayoutComponent: FC<LayoutProps> = (props) => {
  const { pageIsReady, artistName, artistUserId, category, currentTab } = props
  const [shouldLoadComponent, setShouldLoadComponent] = useState(false)

  const { getSearchProviderAttributes } = useSearchProvider()
  const productType = useSelector(getCurrentProductType)
  const artworkId = useSelector(getArtworkId)
  const artworkTitle = useSelector(getArtworkTitle)
  const originalPrice = useSelector(getOriginalProductListPrice)
  const sku = useSelector(getSelectedProductSku)
  const printAditionalPrice = useSelector(getTotalPriceInCentsOfSelectedOptions)
  const printSelectedProduct = useSelector(getSelectedProduct)
  const { listPrice } = printSelectedProduct
  const printprice = listPrice + printAditionalPrice
  const isPrint = productType === PRINT

  const baseLink = `/${slugify(getLinkCategory(category) || 'all')}`
  const medium =
    currentTab !== 'original' && currentTab !== 'info' ? 'Prints' : getLinkCategory(category)
  const mediumLink = currentTab !== 'original' ? '/prints' : baseLink
  const capitalizedArtistName = capitalizeString(artistName)
  const capitalizedArtworkTitle = capitalizeString(artworkTitle)

  return (
    <>
      {pageIsReady && (
        <DisableContextMenu>
          <div className={styles.pdpBreadcrumbContainer}>
            <Breadcrumb
              items={[
                {
                  name: 'All Artworks',
                  title: 'See all artworks',
                  url: '/all',
                },
                {
                  name: medium,
                  title: 'See more artworks',
                  url: mediumLink,
                },
                {
                  name: `${capitalizedArtistName} Works`,
                  title: `See more Artworks by ${capitalizedArtistName}`,
                  url: `/account/artworks/${artistUserId}`,
                },
              ]}
            />
          </div>

          <MainContent
            {...getSearchProviderAttributes([
              { 'product-detail-container': true },
              { 'item-id': artworkId },
              { 'item-variation-id': sku },
              { 'item-name': capitalizedArtworkTitle },
              { 'item-price': isPrint ? printprice : originalPrice },
            ])}
          >
            <Gallery />

            <Products />
          </MainContent>

          <Admin />

          <ArtworkDescriptionSection />

          <VisibilityTrigger setShouldLoadComponent={setShouldLoadComponent} />

          <AboutArtist />

          <Carousels
            shouldLoadComponent={shouldLoadComponent}
            setShouldLoadComponent={setShouldLoadComponent}
          />

          <USPSection />
          <AASection />
          <RelatedSearches />
        </DisableContextMenu>
      )}
    </>
  )
}
export default LayoutConnector(PDPLayoutComponent)
